
import { defineCommand } from '../../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../../concepts/commands/CommandRegistry';
import { resolveSubject } from '../../../canvas/commands/CommandUtil';
import { WidgetManager } from '../../../canvas/workspace/widgets/WidgetManager';
import { jiraOAuthRequiredPopup } from '../../../external/atlassian/JiraOAuthRequiredPopup';
import { PopupManager } from '../../../popups/PopupManager';
import { jiraReload } from '../AtlassianCommands';
import { AtlassianContext } from '../AtlassianContext';
import { JiraCard } from '../JiraCard';
import { JiraSidebarWidget } from './JiraSidebarWidget';

export const jiraSidebarOpen = defineCommand(
    'jiraSidebarOpen',
    'Jira Sidebar: Open',
    async (cc, [targetId]: [string?]) => {

        const atlassian = cc.call(AtlassianContext);
        const popups = cc.call(PopupManager);
        const widgets = cc.call(WidgetManager);
        const subject = resolveSubject(cc, targetId)?.as(JiraCard);
        if (!subject) return false;

        if (!atlassian.ready()) {
            const { actioned } = await popups.invoke(jiraOAuthRequiredPopup());
            if (!actioned) return false;
        }

        widgets.delete('jiraSidebar');
        const cont = widgets.createContainer({
            name: 'jiraSidebar',
            position: ['attached', { to: subject.id, placement: 'right', offset: [1, 2], zOrder: 111 }],
            direction: 'row',
            style: 'none',
        });

        cont.add(widgets.createInline({ ui: JiraSidebarWidget, subject }));
        widgets.add(cont);

        // Reload on open
        cc.dispatch(jiraReload, [[subject.id]]);
        return true;
    }
);

export const jiraSidebarClose = defineCommand(
    'jiraSidebarClose',
    'Jira Sidebar: Close',
    r => {
        const widgets = r.call(WidgetManager);
        widgets.delete('jiraSidebar');
        return true;
    }
);

export const inJiraSidebarCommands = () => inCommands(
    jiraSidebarOpen,
    jiraSidebarClose,
);

